import type { FC, PropsWithChildren } from 'react'

import { ErrorText } from '@/components/ui/error-text'

export const FormItem: FC<
  PropsWithChildren<Partial<Record<'label' | 'error', string>>>
> = ({ label, error, children }) => {
  return (
    <div>
      <div className="flex flex-col gap-2">
        <label className="w-full text-sm font-medium text-text-default">
          {label}
        </label>
        {children}
      </div>
      {error && <ErrorText>{error}</ErrorText>}
    </div>
  )
}
